export default "__VITE_ASSET__W1YIS0al__"